import React from "react";
import { partnerLogos } from "../utils/mockData";

export const TrustSection = () => {
  return (
    <section className="py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 mb-12 text-center">
        <h2 className="text-2xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
          Dipercaya oleh Mitra & Klien
        </h2>
        <div className="w-20 h-1 bg-[#D32F2F] mx-auto rounded-full"></div>
      </div>

      {/* Container untuk Loop Scroll */}
      <div className="relative flex overflow-x-hidden">
        {/* Row Pertama */}
        <div className="flex animate-infinite-scroll whitespace-nowrap items-center">
          {[...partnerLogos, ...partnerLogos].map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center mx-4 w-40 h-24 sm:w-48 sm:h-28 
                         bg-white/50 dark:bg-white/5 backdrop-blur-sm
                         border border-gray-200 dark:border-gray-800 
                         rounded-2xl px-8 transition-all duration-300
                         group hover:border-[#D32F2F]/50"
            >
              <span
                className="text-gray-400 dark:text-gray-500 font-bold text-lg sm:text-xl 
                               grayscale group-hover:grayscale-0 group-hover:text-[#D32F2F] 
                               transition-all duration-300"
              >
                {partner}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Overlay Gradient (Efek memudar di pinggir) */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white dark:from-[#0a0a0a] to-transparent hidden md:block"></div>
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white dark:from-[#0a0a0a] to-transparent hidden md:block"></div>
    </section>
  );
};
